import * as React from "react";

export const UnlockedIcon: React.SFC = ({}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g
      id="unlocked"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="noun_Unlock_2233631_000000"
        transform="translate(4.000000, 2.000000)"
        fill="#747474"
        fillRule="nonzero"
      >
        <path
          d="M13.3,7.04626465 L13.3,5.25 C13.3,2.35503333 10.9449667,0 8.05,0 C5.76242065,0 3.13246765,1.41986793 3.13246765,4.31483459 L3.13246765,4.49986267 L5.23246765,4.49986267 L5.23246765,4.2348175 C5.46450806,2.56585693 6.85510254,2.1 8.05,2.1 C9.78693333,2.1 11.2,3.51306667 11.2,5.25 L11.2,7.04626465 L2.1,7.04626465 C0.9401,7.04626465 0,7.98636465 0,9.14626465 L0,18.9 C0,20.0599 0.9401,21 2.1,21 L13.3,21 C14.901123,21 16.1381836,20.6132812 16.1381836,18.9 L16.1381836,9.14626465 C16.1381836,7.92617798 15.3995361,6.93182373 13.3,7.04626465 Z M7.90040816,16 C6.78918367,16 5.88,15.1 5.88,14 C5.88,12.9 6.78918367,12 7.90040816,12 C9.01163265,12 9.92081633,12.9 9.92081633,14 C9.92081633,15.1 9.01163265,16 7.90040816,16 Z"
          id="Shape"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/documentList/UnlockedIcon.tsx